<script lang="ts">
  import ClipboardJS from 'clipboard';
  import { onMount } from 'svelte';

  import CloseSvg from '@/comps-sdk/components/icon/close.svelte';
  import Popup from '@/comps-sdk/components/popup';
  import { toast as Toast } from '@/comps-sdk/components/toast';

  // 弹窗基本设置
  export let showPopup = false;
  export let getContainer = 'body';
  export let closeOnClickOverlay = false;
  export let onClose: () => void = () => {};
  // 弹窗内部设置
  export let title = '';
  export let text = '';

  let btnEl: HTMLElement | null = null;
  let clipboard: ClipboardJS;

  onMount(() => {
    clipboard = new ClipboardJS(btnEl!, {
      text() {
        return text;
      },
    });

    clipboard.on('success', () => {
      Toast('复制成功');
    });

    clipboard.on('error', () => {
      Toast('抱歉～当前环境不支持复制功能，请手动复制哦');
      throw new Error('无法复制');
    });
  });

  const handleClose = async () => {
    if (typeof onClose === 'function') {
      await onClose();
    }
    showPopup = false;
  };
</script>

<Popup
  class={'act-sdk-iwan-share-popup'}
  bind:value={showPopup}
  position="center"
  closable={false}
  {closeOnClickOverlay}
  {getContainer}
  on:clickOverlay={handleClose}
>
  <div class="boost_pop_content large">
    <div class="header">
      {title}
    </div>
    <div class="content">
      {text}
    </div>
    <button bind:this={btnEl} class="footer_btn">复制</button>
  </div>
  <div class="close_button" role="button" tabindex="0" on:click={handleClose} on:keyup={() => {}}>
    <CloseSvg color="#fff" />
  </div>
</Popup>

<style lang="scss">
  :global(.act-sdk-iwan-share-popup) {
    overflow: visible !important;
    background: transparent !important;
  }
  .boost_pop_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    width: 250px;
    min-height: 148px;
    background: #fff;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 60px;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: right;
    color: #111111;
  }
  .content {
    margin: 0 16px 20px 20px;
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    color: #666666;
  }
  .footer_btn {
    width: 166px;
    padding: 10px 0;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
    color: #111111;
    border: none;
    border-radius: 20px;
    background: #ffdc14;
    box-shadow: 0px 2px 4px 0px #ffdc0026;
  }
  .large {
    width: 285px;
  }
  .close_button {
    position: absolute;
    right: 0;
    top: -39px;
    transform: translateY(-50%);
  }
</style>
